import * as React from 'react';
import { observer } from 'mobx-react';
import { WithStyles, withStyles } from '@material-ui/core/styles';
import withWidth, { WithWidth } from '@material-ui/core/withWidth';

import container from '@Clinic/core/di-container';
import { LayoutView } from '@Clinic/core/Layout/Layout.constants';
import LegalInfoStore from '@Clinic/shared/stores/legal-info';
import LayoutStore from '@Clinic/shared/stores/layout';
import ROUTES from '@Clinic/shared/constants/routes';
import ErrorHandler from '@shared/components/ErrorHandler';
import Loading from '@shared/components/Loading';
import Button from '@shared/components/Button';
import history from '@shared/utils/history';
import { filterXSS } from '@shared/utils/common';

import styles from './PrivacyPolicy.styles';

export interface PrivacyPolicyProps extends WithStyles<typeof styles>, WithWidth {}

@observer
class PrivacyPolicy extends React.Component<PrivacyPolicyProps> {
  private layoutStore = container.get<LayoutStore>(LayoutStore.diToken);
  private legalInfoStore = container.get<LegalInfoStore>(LegalInfoStore.diToken);

  constructor(props: PrivacyPolicyProps) {
    super(props);

    this.initialize();
  }

  private initialize = async () => {
    this.updateLayout();

    await this.legalInfoStore.getPrivacyPolicy();
  };

  componentDidUpdate(prevProps: PrivacyPolicyProps) {
    if (prevProps.width !== this.props.width) {
      this.updateLayout();
    }
  }

  private updateLayout = () => {
    const { updateConfig, view } = this.layoutStore;

    updateConfig({
      content: {
        width: view === LayoutView.desktop ? '80vw' : '100%',
      },
      navigationProps: {
        backButtonProps: {
          onClick: this.close,
        },
        pageDescription: 'Privacy policy',
      },
    });
  };

  componentWillUnmount() {
    this.layoutStore.setDefaultConfig();
  }

  private close = () => history.push(ROUTES.public.signUp);

  render() {
    const { classes } = this.props;
    const { error, loading, privacyPolicy } = this.legalInfoStore;
    const sanitizedHTML = privacyPolicy ? filterXSS(privacyPolicy) : '';

    if (error.privacyPolicy) {
      return <ErrorHandler />;
    }

    if (loading.privacyPolicy) {
      return <Loading classes={{ root: classes.loading }} />;
    }

    return (
      <div className={classes.root}>
        <div
          className={classes.text}
          dangerouslySetInnerHTML={{
            __html: sanitizedHTML,
          }}
        />
        {this.layoutStore.view === LayoutView.mobile && (
          <Button fullWidth text="Close" color="secondary" onClick={this.close} />
        )}
      </div>
    );
  }
}

export default withWidth()(withStyles(styles)(PrivacyPolicy));
